import { render, staticRenderFns } from "./RemnantGainFactor.vue?vue&type=template&id=22b0df19&"
import script from "./RemnantGainFactor.vue?vue&type=script&lang=js&"
export * from "./RemnantGainFactor.vue?vue&type=script&lang=js&"
import style0 from "./RemnantGainFactor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports